import Request from '../util/request';
import {
  ajax
} from "../util/ajaxUtil";
import store from '../store/index'
import {
  formatDate
} from "../util/formatUtil";
// import { makePinYin } from "../util/pingyinUtil";

const path = "/eip-mapp-tmpl-server/"
const bpmPath = '/eip-mapp-bpm-working-server'

const curUser = store.state.user || {};

export let loginUserTenantId = curUser.tenantId;
export let loginPsnCode = curUser.psnCode;
export let loginPsnName = curUser.psnName;
export let loginUserJobName = curUser.jobName;
export let loginUserGrpId = curUser.userGrpId;
export let loginUserGrpCode = curUser.userGrpNumber;
export let loginUserGrpNumber = curUser.userGrpNumber;
export let loginUserGrpName = curUser.userGrpName;
export let loginDeptNumber = curUser.deptNumber;
export let loginDeptName = curUser.deptName;
export let loginCenterNumber = curUser.centerNumber;
export let loginCenterName = curUser.centerName;
export let loginCompanyNumber = curUser.companyNumber;
export let loginCompanyName = curUser.companyName;


export function datetime() {
  return formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
}

export function date() {
  return formatDate(new Date(), 'yyyy-MM-dd')
}

export function parseDate(dateStr) {
  if (!dateStr) {
    return new Date();
  }
  var userAgent = navigator.userAgent;
  if (userAgent.indexOf('Safari') > -1) {
    dateStr = dateStr.replace(/\-/g, '/');
  }
  return new Date(dateStr);
}

export function format(date, fmt) {
  return formatDate(date, fmt)
}

export function getPinyin(date) {
  return window.makePinYin(date)
}


export function getFunTransactionPageInfo(funCode) {
  return Request({
    url: path + '/tmpl/getFunTransactionPageInfo',
    method: 'post',
    data: {
      funCode: funCode
    }
  })
}

export function getFunTransactionFlowInfo(funCode, businessId, procId, taskId, shareCode, shareTaskId, trueTaskId) {
  return Request({
    url: bpmPath + '/proc-info/config',
    method: 'post',
    data: {
      funCode: funCode,
      businessId: businessId === 'undefined' ? '' : businessId,
      procInstId: procId,
      taskId: taskId,
      shareCode: shareCode,
      shareTaskId,
      trueTaskId
    },
    options: {
      noConfirmationPrompt: true
    }
  })
}

export function getActiveRegList(misService, funCode, data) {
  return Request({
    url: path + '/tmpl/web/activeReg/' + misService + '/funCode/' + funCode,
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return Request({
    url: path + '/tmpl/data/getPageList',
    method: 'post',
    data
  })
}

export function getSubList(data) {
  return Request({
    url: path + '/tmpl/data/getSubList',
    method: 'post',
    data
  })
}

export function getTableData(data) {
  return Request({
    url: path + '/tmpl/data/getTableData',
    method: 'post',
    data
  })
}

export function getMsSignValueById(tableName, fieldNames, whereCol, val) {
  let params = {
    tableName: tableName,
    fieldNames: fieldNames,
    where: "1=1 and " + whereCol + "='" + val + "'"
  }
  let data;
  ajax({
    url: path + 'tmpl/formulaMs/getMsSignValueByWhere',
    method: 'post',
    contentType: 'application/json;charset=utf-8',
    data: params,
    success: function (res) {
      if (res.success) {
        data = res.data;
      }
    },
    async: false
  })
  return data;
}

export function getProjectInfo(projectCode) {
  let data;
  let url = '/ep/Beacon/api/getProjectInfo';

  ajax({
    url: url,
    method: 'get',
    data: { projectNum: projectCode },
    contentType: 'application/json;charset=utf-8',
    success: function (res) {
      data = res;
    },
    async: false
  })
  return data;
}

export function findProjectMachine(projectCode, roleType) {
  let data;
  let url = '/ep/Beacon/station/findProjectMachine';

  ajax({
    url: url,
    method: 'get',
    data: { projectNum: projectCode, name: roleType },
    contentType: 'application/json;charset=utf-8',
    success: function (res) {
      data = res;
    },
    async: false
  })
  return data;
}

export function getMsSignValueByWhere(tableName, fieldNames, where) {
  let params = {
    tableName: tableName,
    fieldNames: fieldNames,
    where: where
  }
  let data;
  ajax({
    url: path + 'tmpl/formulaMs/getMsSignValueByWhere',
    method: 'post',
    contentType: 'application/json;charset=utf-8',
    data: params,
    success: function (res) {
      if (res.success) {
        data = res.data;
      }
    },
    async: false
  })
  return data;
}

export function getMsListValueByWhere(data) {
  return getData("getMsListValueByWhere", data);
}

export function getMsPageValueByWhere(data) {
  return getData("getMsPageValueByWhere", data);
}

export function getData(method, data) {
  return Request({
    url: path + '/tmpl/formulaMs/' + method,
    method: 'post',
    data
  })
}

export function execute(data) {
  return Request({
    url: path + '/tmpl/data/execute',
    headers: {
      procInstId: data.procInst.id
    },
    method: 'post',
    data
  })
}

export function doExport(data) {
  return Request({
    url: path + '/tmpl/data/export',
    method: 'post',
    data,
    timeout: 0
  })
}

export function exportSubData(data) {
  return Request({
    url: path + '/tmpl/data/exportSubData',
    method: 'post',
    data,
    timeout: 0
  })
}

export function exportHidden(data) {
  return Request({
    url: path + '/oaDataReport/export',
    method: 'post',
    responseType: "blob",
    data,
    timeout: 0
  })
}


export function findHideColumn(data) {
  return Request({
    url: path + '/tmplFieldHidden/findTemplateFieldHidden',
    method: 'post',
    data
  })
}

export function saveHideColumn(data) {
  return Request({
    url: path + '/tmplFieldHidden/saveTemplateFieldHidden',
    method: 'post',
    data: data
  })
}

export function post(url, params) {
  let data;
  ajax({
    url: url,
    method: 'post',
    contentType: 'application/json;charset=utf-8',
    data: params,
    success: function (res) {
      if (res) {
        data = res;
      }
    },
    async: false
  })
  return data;
}

export function get(url) {
  let data;
  ajax({
    url: url,
    method: 'get',
    contentType: 'application/json;charset=utf-8',
    success: function (res) {
      if (res) {
        data = res;
      }
    },
    async: false
  })
  return data;
}

// 分享权限设置
export function shareInfo(data) {
  return Request({
    url: '/eip-mapp-bpm-working-server/share_info/save',
    method: 'post',
    data
  })
}

// 设置流程编号
export function getProcNumber(indexKey) {
  let data
  ajax({
    url: '/eip-mapp-tablekeyindex-server/generateCodeValue/generateCodeValueByTenantID',
    method: 'post',
    contentType: 'application/json;charset=utf-8',
    data: { tenantID: 2288, indexKey: indexKey + '_code' },
    success: function (res) {
      if (res.success) {
        data = res.data
      }
    },
    async: false
  })
  return data
}

// 审批要素今日不再提醒接口
export function getRedisUserRemindAndOne(data) {
  return Request({
    url: `/eip-mapp-oa-server/approver_user/getRedisUserRemindAndOne/${data.funCode}`,
    method: 'post',
    data
  })
}
// 获取审批要素今日不再提醒接口
export function getUserBoolean(data) {
  return Request({
    url: `/eip-mapp-oa-server/approver_user/getUserBoolean/${data.funCode}`,
    method: 'post',
    data
  })
}

// 表单初始化
export function formInitialize(tableName) {
  if (!tableName.sqr) {
    // 先判断是否已存在申请人，不存在才进行赋值
    tableName.sqr = $.loginPsnName // 姓名
    tableName.gh = $.loginPsnCode // 工号
    tableName.bmID = $.loginDeptNumber // 部门ID
    tableName.bm = $.loginDeptName // 部门
    tableName.gs = $.loginCompanyName // 公司
    tableName.zx = $.loginCenterName // 中心
    tableName.sqrq = $.date() // 当前日期
  }
  return tableName
}

// 系统自动分配审批人赋值
export function automaticAllocat(flowForm, taskDefinitionKey) {
  flowForm[taskDefinitionKey].push({ code: '0', name: '系统自动分配' })
}

// 获取字段内容
export function getField(fieldName, columnList, tableName) {
  return columnList[tableName].find(obj => {
    return obj.ItemKey === fieldName
  })
}

// 根据内容显示隐藏字段
export function hiddenFields(value1, value2, fieldNames, tableName, columnList, multiple) {
  fieldNames.forEach(fieldName => {
    let fieldNameItem = columnList[tableName].find(obj => {
      return obj.ItemKey === fieldName
    })
    if (multiple) {
      // 下拉多选
      fieldNameItem.CardShowFlag = value1.indexOf(value2) !== -1
    } else {
      fieldNameItem.CardShowFlag = value1 === value2
    }
  })
}

// 下拉框赋值下列选项
export function assignValue(tableName, fieldName, url, columnList) {
  // 清空字段值
  tableName[fieldName] = null
  let res = $.post(url)
  if (res.success && res.data) {
    columnList[tableName].forEach(item => {
      // 获取到需要赋值下拉选项的字段
      if (item.ItemKey === 'fieldName') {
        item.DropDownListEntitys = []
        res.data.forEach(obj => {
          let arr = item.DropDownListEntitys.filter(sItem => { return sItem.value === obj.value })
          if (!arr.length) item.DropDownListEntitys.push({ label: obj.label, value: obj.value })
        })
      }
    })
  }
}

// 按钮显示隐藏
export function buttonHidden(sysFunActiveIDs, status, buttonList) {
  buttonList.forEach(btn => {
    sysFunActiveIDs.forEach(sysFunActiveID => {
      if (btn.sysFunActiveID === sysFunActiveID) {
        btn.forBidFlag = !status
      }
    })
  })
}

// 合计
export function totalCalculat(dataList, fieldName) {
  let sum = 0
  dataList.forEach(item => {
    let number = Number(item[fieldName])
    if (isNaN(number)) {
      number = 0
    }
    sum += number
  })
  return sum
}

// 数据转换
export function dataConversion(value) {
  // 将null undefined等转换为0
  let number = Number(value)
  if (isNaN(number)) {
    number = 0
  }
  return number
}

// 设置字体
export function setFontStyle(type, text, setArr) {
  setTimeout(function () {
    let label = '.normal-label'
    if (type === 'value') {
      label = '.disable-value-font'
    }
    document.querySelectorAll(label).forEach(item => {
      if (item.innerText === text) {
        setArr.forEach(type => {
          item.style[type.label] = type.value
        })
      }
    })
  }, 300)
}

// 根据省份赋值赋值区域
export function setArea(tableName, provinceName, areaName) {
  let province = tableName[provinceName]
  let areaList = [
    { provinces: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区'], area: '华北' },
    { provinces: ['辽宁省', '吉林省', '黑龙江省'], area: '东北' },
    { provinces: ['上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省'], area: '华东' },
    { provinces: ['河南省', '湖北省', '湖南省'], area: '华中' },
    { provinces: ['广东省', '广西壮族自治区', '海南省'], area: '华南' },
    { provinces: ['重庆市', '四川省', '贵州省', '云南省', '西藏自治区'], area: '西南' },
    { provinces: ['陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区'], area: '西北' },
    { provinces: ['香港特别行政区', '澳门特别行政区', '台湾省'], area: '港澳台' },
  ]
  if (province && province[0]) {
    areaList.forEach(item => {
      if (item.provinces.indexOf(province[0]) !== -1) {
        tableName[areaName] = item.area
      }
    })
  }
  return tableName[areaName]
}

// 根据流程编号获取流程
export function setProc(procNum, procKey, editFormData, tableName, fieldName) {
  ajax({
    url: '/eip-mapp-oa-server/query_pro_info/getProcStatus',
    method: 'post',
    contentType: 'application/json;charset=utf-8',
    data: { lcbh: procNum, procKey: procKey },
    success: function (res) {
      if (res.success) {
        let data = res.data
        editFormData[fieldName] = [{
          "id": data.proInstId,
          "name": data.procName,
          "funCode": data.funCode,
          "businessID": data.businessKey,
          "endTime": data.endTime,
          "createTime": data.startTime,
          "approvalStatus": data.taskStatus,
          "activeTask": null,
          "activeTaskTime": data.lastUpdateTime
        }]
        tableName[fieldName] = editFormData[fieldName]
      }
    },
    async: false
  })
}

export function getImportPsncode(tableData, buttonList, notify, removeRepetition, isValidateForbidden, name) {
  // 批量导入工号查询用户信息
  let fieldName = name || 'gh1'
  let isForbidden = isValidateForbidden || true
  let isRemove = removeRepetition || false
  var deleteUser = []
  var notFindUser = []
  var repetitionUser = []
  var userList = []
  tableData.forEach(data => {
    if (userList.indexOf(data[fieldName]) !== -1 && repetitionUser.indexOf(data[fieldName]) === -1) {
      repetitionUser.push(data[fieldName])
    }
    if (data[fieldName] && data[fieldName].toString().length == 5) {
      userList.push(data[fieldName])
    }
  })
  console.log(repetitionUser)
  ajax({
    url: '/eip-mapp-umc-server/userGrp/getUserGrpInfosByPsnCodes',
    method: 'post',
    contentType: 'application/json;charset=utf-8',
    data: userList,
    success: function (res) {
      if (res.success) {
        tableData.forEach(data => {
          let item = res.data[data[fieldName]]
          if (item) {
            data.xm = item.psnName
            data.zw = item.jobName
            data.zx = item.centerName
            data.bm1 = item.deptName
            data.zb = item.userGrpName
            data.zt = item.isForbidden ? '离职' : '在职'
            if (item.isForbidden) {
              deleteUser.push(item.psnCode)
            }
          } else {
            notFindUser.push(data.gh1)
          }
        })
        let isCommit = true
        if (notFindUser.length) {
          notify({
            title: '提示',
            message: '<div style="white-space: normal; word-break: break-all;">未查到' + notFindUser.join(',') + '工号人员</div>',
            dangerouslyUseHTMLString: true,
            type: 'warning',
            duration: 8000
          })
          isCommit = false
        }
        if (deleteUser.length && isForbidden) {
          notify({
            title: '提示',
            message: '<div style="white-space: normal; word-break: break-all;">' + deleteUser.join(',') + '工号人员已离职</div>',
            dangerouslyUseHTMLString: true,
            type: 'warning',
            offset: 100,
            duration: 8000
          })
          isCommit = false
        }
        if (repetitionUser.length && isRemove) {
          notify({
            title: '提示',
            message: '<div style="white-space: normal; word-break: break-all;">' + repetitionUser.join(',') + '工号人员存在重复</div>',
            dangerouslyUseHTMLString: true,
            type: 'warning',
            offset: 220,
            duration: 8000
          })
          isCommit = false
        }
        buttonList.forEach(btn => {
          if (btn.sysFunActiveID === 41) {
            btn.forBidFlag = !isCommit
          }
        })
      }
    },
    async: false
  })
}
